import { ErrorBoundary, Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Box, Center, FlatList } from 'native-base';
import React from 'react';

import { TableHeadContainer, TableHeadItem } from '../../../../components/TableHead';
import { ItemSeparator } from '../../../BatchTicket/components/ItemSeparator';
import { flatListProps } from '../../../BatchTicket/utils';
import { BasketAdvisorListResponseProps, orderByProps } from '../../../BatchTicket/utils/types';
import { flatlistMaxH, tableHeadBatchTicketRequestsData } from '../../utils';
import { ItemTable } from '../ItemTable';
import { SkeletonItem } from '../SkeletonItem';

interface TableProps {
  orderBy?: orderByProps;
  handleOrderBy?: (value?: string) => void;
  isLoading: boolean;
  isLoadingMore: boolean;
  error?: Error;
  response: BasketAdvisorListResponseProps;
  refresher: () => void;
  onEndReached?: () => void;
  skeletonItemCount: number;
}

export const Table: React.FC<TableProps> = ({
  isLoading,
  isLoadingMore,
  refresher,
  response,
  error,
  onEndReached,
  skeletonItemCount,
}) => {
  return (
    <VStack space={Spacing['inline.nano']} flex={1} {...(error && { pb: Spacing['inline.xxxs'] })}>
      {!error && response && response?.data?.length > 0 && (
        <TableHeadContainer space={Spacing['inline.nano']}>
          {tableHeadBatchTicketRequestsData.map((item) => (
            <TableHeadItem key={item.title} {...item} />
          ))}
        </TableHeadContainer>
      )}
      <Shadow level={2} flex={0.95} borderTopRadius={BoxRadius.sm}>
        {isLoading && <SkeletonItem itemsCount={skeletonItemCount} />}
        {!isLoading && !error && response && response?.data?.length > 0 && (
          <FlatList
            {...flatListProps}
            data={response?.data}
            keyExtractor={(item) => item.correlationId}
            ItemSeparatorComponent={ItemSeparator}
            maxH={flatlistMaxH}
            onEndReached={onEndReached}
            flex={1}
            ListFooterComponent={
              <Box py={Spacing['inline.quarck']}>{isLoadingMore && <SkeletonItem />}</Box>
            }
            renderItem={({ item }) => <ItemTable item={item} />}
          />
        )}
        {!isLoading && error && (
          <Center flex={1}>
            <ErrorBoundary onRefresh={refresher} {...error} />
          </Center>
        )}
        {!isLoading && !error && response && response?.data?.length === 0 && (
          <Center flex={1}>
            <ErrorBoundary
              errorIconOrIllustration="NotEmptyIllustration"
              errorTitle="Você ainda não enviou nenhuma solicitação"
              errorMessage="No momento não há dados disponíveis para este tipo de solicitação."
            />
          </Center>
        )}
      </Shadow>
    </VStack>
  );
};
